<template>
  <nav
    class="flex fixed z-50 justify-between items-baseline py-4 px-6 w-full text-primary md:text-lg lg:text-xl bg-primary md:px-12">
    <div class="flex justify-between items-center md:w-1/2">
      <div class="relative">
        <!--        Logo -->
        <router-link :to="{name: 'About'}" class="hover:text-secondary">
        <span class="absolute -top-8 z-10 md:left-0">
          <span class="sr-only">Home</span>
          <svg class="w-12 h-12 fill-current md:w-16 lg:w-20 md:h-16 lg:h-20" width="166" height="173"
               viewBox="0 0 166 173" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M140.303 74.7104C138.86 76.2335 137.217 77.3558 135.373 78.0773C143.229 79.1995 149.201 82.0053 153.289 86.4945C157.378 90.9035 159.422 96.3145 159.422 102.728C159.422 110.504 156.296 116.796 150.043 121.606C143.79 126.416 135.573 128.821 125.392 128.821C115.212 128.821 107.235 126.336 101.463 121.366C95.6917 116.315 92.8058 109.221 92.8058 100.082C92.8058 99.6012 92.8058 99.1203 92.8058 98.6393L94.1285 98.3988C95.7318 110.343 100.702 118.079 109.039 121.606V51.6232C108.879 49.4588 108.037 47.6952 106.514 46.3324C105.071 44.8894 103.307 44.168 101.223 44.168H99.78V42.9655H119.981C127.517 42.9655 133.529 44.689 138.018 48.1361C142.588 51.5831 144.872 56.1124 144.872 61.7238C144.872 67.2551 143.349 71.584 140.303 74.7104ZM116.855 46.8134V123.771C119.5 124.171 122.547 124.372 125.994 124.372C133.689 124.372 139.662 122.328 143.91 118.239C148.239 114.071 150.403 108.7 150.403 102.126C150.403 98.5992 149.722 95.4728 148.359 92.7472C147.077 90.0217 145.433 87.8973 143.429 86.3742C138.138 82.2859 130.683 80.2417 121.064 80.2417C120.983 80.2417 120.943 80.2417 120.943 80.2417L120.823 79.1595C120.903 79.1595 120.943 79.1595 120.943 79.1595C125.032 79.1595 128.519 77.8368 131.405 75.1914C134.371 72.4658 135.854 68.2973 135.854 62.6858C135.854 52.1042 130.042 46.8134 118.418 46.8134H116.855Z"
              class="fill-current"/>
            <path
              d="M116.518 137.923C106.337 137.923 98.0003 134.676 91.507 128.183C86.6972 123.373 83.5307 117.321 82.0076 110.026C74.392 115.798 65.0529 118.683 53.9903 118.683C45.2525 118.683 37.2762 116.8 30.0614 113.032C22.9269 109.184 17.3154 103.933 13.227 97.2797C9.21884 90.6261 7.21474 83.1308 7.21474 74.7937C7.21474 66.4567 9.21884 58.9614 13.227 52.3078C17.3154 45.574 22.9269 40.3634 30.0614 36.6758C37.196 32.9883 45.1723 31.1445 53.9903 31.1445C65.0529 31.1445 74.7928 33.8701 83.21 39.3213L85.615 56.2759H84.5327C82.1278 46.9769 76.6767 40.644 68.1793 37.2771C64.0108 35.5936 59.2811 34.7519 53.9903 34.7519C43.1682 34.7519 34.1498 38.5196 26.935 46.055C19.8005 53.5904 16.2332 63.17 16.2332 74.7937C16.2332 86.3373 19.8405 95.9169 27.0553 103.532C34.27 111.148 43.2484 114.996 53.9903 115.076C59.201 115.076 64.1711 114.154 68.9008 112.31C73.6305 110.467 77.6787 107.901 81.0456 104.615V83.3312C81.0456 81.5676 80.5246 80.2449 79.4824 79.3631C78.4403 78.4011 76.9573 77.9201 75.0333 77.9201H73.1094V76.7177H96.6776V77.9201H94.8739C92.8698 77.9201 91.3467 78.4011 90.3045 79.3631C89.2624 80.2449 88.7814 81.5676 88.8616 83.3312V101.849C89.3426 114.515 93.471 123.573 101.247 129.025C106.698 132.872 113.752 134.796 122.41 134.796C126.018 134.796 129.946 134.436 134.194 133.714L134.314 134.917C127.901 136.921 121.969 137.923 116.518 137.923Z"
              class="fill-current"/>
            <path
              d="M164.258 104.448C165.142 104.546 165.782 105.342 165.648 106.22C164.757 112.065 162.551 117.638 159.189 122.517C155.826 127.396 151.403 131.441 146.259 134.354C145.485 134.792 144.513 134.477 144.108 133.686C143.702 132.896 144.016 131.929 144.788 131.488C149.46 128.82 153.478 125.132 156.539 120.691C159.6 116.25 161.616 111.182 162.447 105.866C162.584 104.988 163.375 104.351 164.258 104.448Z"
              class="fill-current"/>
          </svg>
        </span>
        </router-link>
        <!--        Mobile arch around logo-->
        <div class="absolute -left-7 -top-16 w-24 h-24 rounded-full border-1 border-gold md:hidden bg-primary"></div>
        <!--        Arch for medium screen and above -->
        <div
          class="border-b-1.5 transform rotate-12 border-r-1.5 border-gold w-44 h-44 lg:w-64 lg:h-60 rounded-br-full md:-top-20 lg:-top-24 -left-12 absolute hidden md:block bg-primary"></div>
      </div>
      <div class="flex hidden relative flex-row md:inline-flex">
        <ul
          class="flex justify-between items-center place-self-center space-x-8 tracking-wider capitalize md:-right-16 lg:space-x-12 md:absolute">
          <router-link :to="{name: 'About'}" tag="li" exact-active-class="text-secondary"
                       class="hover:text-active focus:text-secondary">
            <span>About</span>
          </router-link>
          <router-link :to="{name: 'Projects'}" tag="li" exact-active-class="text-secondary"
                       class="hover:text-active focus:text-secondary"><span>Projects</span>
          </router-link>
          <router-link :to="{name: 'Contact'}" tag="li" exact-active-class="text-secondary"
                       class="hover:text-active focus:text-secondary"><span>Contact</span>
          </router-link>
        </ul>
      </div>
    </div>
    <div class="flex justify-between items-center space-x-8 md:space-x-6">
      <div class="px-1">
        <button @click.prevent="switchTheme" class="outline-none focus:outline-none no-highlight">
          <i :class="switchIcon" class="text-primary md:text-xl focus:outline-none no-highlight"></i>
          <span class="sr-only">Change Theme</span>
        </button>
      </div>
      <div
        class="capitalize border-1.5 border-secondary text-secondary hover:text-active focus:text-secondary rounded px-2 md:rounded-lg md:px-7 md:py-2 hidden md:inline-flex">
        <a :href="`https://drive.google.com/file/d/1oYrJxHgXdm0e6o3ZlzWlqq2yETGApEd0/view?usp=sharing`" rel="noreferrer"
           target="_blank"
           class="text-xs tracking-tighter md:text-base md:tracking-wider">Resume</a></div>
      <button class="border-0 cursor-pointer outline-none md:hidden focus:outline-none no-highlight"
              @click="trackHamburgerClick"><span class="sr-only">Menu</span>
        <svg class="w-8 h-8 transform rotate-180 fill-current focus:outline-none no-highlight" fill="none"
             stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             v-if="hamburgerStatus === 'open'">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16"></path>
        </svg>
        <i class="text-3xl opacity-50 fas fa-times text-primary" v-if="hamburgerStatus === 'close'"></i>
      </button>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'mainHeader',
  computed: {
    ...mapGetters(['switchIcon', 'hamburgerStatus'])
  },
  methods: {
    ...mapActions(['switchTheme', 'trackHamburgerClick'])
  }
}
</script>
<style>
.no-highlight {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
